export const USER_ROLES = {
  TRAINEE_MENTOR: 1,
  MANAGEMENT_TEAM: 2,
  PARENT: 3,
  ADMISSION_HEAD: 4,
  ADMIN: 5,
  MENTOR: 6,
  CENTRE_HEAD: 7,
  SUPER_ADMIN: 12,
};

export const USER_ROLE_KEYS = {
  ADMIN: "Admin",
  PARENT: "parent",
  // STUDENT: "student",
  STAFF: "Support Staff",
  TRAINEE_MENTOR: "Trainee Mentor",
  MANAGEMENT_TEAM: "Management Team",
  ADMISSION_HEAD: "Admission Head",
  MENTOR: "Mentor",
  CENTRE_HEAD: "Centre Head",
};

export const ACCESS = {
  ADMIN_OR_MANAGEMENT: [USER_ROLE_KEYS.ADMIN, USER_ROLE_KEYS.MANAGEMENT_TEAM],
  ADMIN_MANAGEMENT_CENTRE_HEAD: [
    USER_ROLE_KEYS.ADMIN,
    USER_ROLE_KEYS.MANAGEMENT_TEAM,
    USER_ROLE_KEYS.CENTRE_HEAD,
  ],
  ALL_CENTRE_ACCESS: [
    USER_ROLE_KEYS.ADMIN,
    USER_ROLE_KEYS.MANAGEMENT_TEAM,
    USER_ROLE_KEYS.CENTRE_HEAD,
    // USER_ROLE_KEYS.STAFF,
    USER_ROLE_KEYS.TRAINEE_MENTOR,
    // USER_ROLE_KEYS.ADMISSION_HEAD,
    USER_ROLE_KEYS.MENTOR,
  ],
  CENTER_HEAD: [USER_ROLE_KEYS.CENTRE_HEAD],
};

export const PAGE_SIZES = [10, 20, 50, 100, 500];

export const getAuthUser = () => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      return authUser || null;
    } catch (error) {
      console.error("Error parsing authUser:", error);
      return null;
    }
  };

export const getGroupedOptions = ({
  categories = [],
  centers = [],
  clusters = [],
  programs = [],
  genders = [],
  payments = [],
  includeGroups = [],
}) => {
  const allGroups = {
    Category: categories.map((category) => ({
      value: `category-${category.category_id}`,
      label: category.category_name,
    })),
    Center: centers.map((center) => ({
      value: `center-${center.center_id}`,
      label: center.center_name,
    })),
    Cluster: clusters.map((cluster) => ({
      value: `cluster-${cluster.cluster_id}`,
      label: cluster.cluster_name,
    })),
    'Program Type': programs.map((program) => ({
      value: `program-${program.program_id}`,
      label: program.program_name,
    })),
    Gender: genders.map((gender) => ({
      value: `gender-${gender}`,
      label: gender,
    })),
    'Payment Channel': payments.map((payment) => ({
      value: `payment-${payment.id}`,
      label: payment.payment_name,
    })),
  };

  // Only include the groups specified in includeGroups
  const filteredGroups = includeGroups.reduce((acc, groupName) => {
    if (allGroups[groupName]) {
      acc.push({
        label: groupName,
        options: allGroups[groupName],
      });
    }
    return acc;
  }, []);

  return filteredGroups;
};

export const INITIAL_FEES_TYPE = {
  re_registration_fees: 'Re-registration Fees',
  registration_fees: 'Registration Fees',
  observation_fees: 'Observation Fees',
};
